module.exports = __webpack_public_path__ + "static/profile-pic-d6dc668c484574f214a79758589629a8.jpg";